export function AdminPage() {

  return (<>
    <div>Admin page</div>
  </>)
}